import { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import { useState } from "react";
import emailjs from "emailjs-com";
import HeroVideo from "@/assets/Hero.mp4";

//Assets
import Homeserimg1 from "@/assets/Homeserimg1.png";
import Homeserimg2 from "@/assets/Homeserimg2.png";
import Homeserimg3 from "@/assets/Homeserimg3.png";
import Homeserimg4 from "@/assets/Homeserimg4.png";
import Homeserimg5 from "@/assets/Homeserimg5.png";
import whatsappicon from "@/assets/icons8-whatsapp-50.png";
import Homegirl from "@/assets/Homegirl.png";
import Ourmission from "@/assets/mission 1.png";
import Ourvision from "@/assets/ourvision.png";
import Archana from "@/assets/test-img-1.png";
import Poonam from "@/assets/test-img-3.png";
import Ranjit from "@/assets/test-img-2.png";
import ContactFrom from "@/Component/ContactForm";
import brochure from "@/assets/E-Brochure.pdf";

type testimonialType = {
  name: string;
  position: string;
  testimonial: string;
  profileImg: string;
};

const testimonials: testimonialType[] = [
  {
    name: "Ranjit Mathure",
    position: "Professional",
    profileImg: Ranjit,
    testimonial:
      "Uma is a very astute and erudite Financial Planner and investment advisor.",
  },
  {
    name: "Dr Poonam Desai",
    position: "Dental Surgeon",
    profileImg: Poonam,
    testimonial:
      "She is very proficient in her work and knows the pulse of the market and I trust her completely.",
  },
  {
    name: "Archana Kalegaonkar",
    position: "Professional",
    profileImg: Archana,
    testimonial:
      "Uma is an extraordinary financial advisor. Her integrity is profound, she will always do the right thing for me.",
  },
];

const categories = [
  {
    name: "Professionals",
    img: Homeserimg1,
    url: "/services",
  },
  {
    name: "Families",
    img: Homeserimg2,
    url: "/services",
  },
  {
    name: "Young Parents",
    img: Homeserimg3,
    url: "/services",
  },
  {
    name: "Women",
    img: Homeserimg4,
    url: "/services",
  },
  {
    name: "NRI Services",
    img: Homeserimg5,
    url: "/services",
  },
];

export default function HomePage() {
  const form = useRef<HTMLFormElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [submitStatus, setSubmitStatus] = useState<{
    success?: boolean;
    message?: string;
  }>({});

  // SEO Meta Tags Setup
  useEffect(() => {
    // Set page title
    document.title = "Oaktree Financial Services - Best Financial Advisor & Wealth Management in Mumbai";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Oaktree Financial Services offers expert financial planning, wealth management, retirement planning, SIP investment, and tax planning in Mumbai. Certified financial advisor and investment consultant.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Oaktree Financial Services offers expert financial planning, wealth management, retirement planning, SIP investment, and tax planning in Mumbai. Certified financial advisor and investment consultant.";
      document.head.appendChild(meta);
    }

    // Meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", "financial advisor, wealth management, retirement planning, SIP investment, financial planner in Mumbai, investment advisor in Mumbai, certified financial advisor Mumbai, mutual fund consultant Mumbai, tax planning consultant Mumbai, portfolio manager in Mumbai, personal finance consultant Mumbai, financial advisor near me");
    } else {
      const meta = document.createElement('meta');
      meta.name = "keywords";
      meta.content = "financial advisor, wealth management, retirement planning, SIP investment, financial planner in Mumbai, investment advisor in Mumbai, certified financial advisor Mumbai, mutual fund consultant Mumbai, tax planning consultant Mumbai, portfolio manager in Mumbai, personal finance consultant Mumbai, financial advisor near me";
      document.head.appendChild(meta);
    }

    // Open Graph Meta Tags
    const ogTags = [
      { property: "og:title", content: "Oaktree Financial Services - Best Financial Advisor in Mumbai" },
      { property: "og:description", content: "Expert financial planning, wealth management, and investment advisory services in Mumbai. Certified financial planner helping you achieve financial freedom." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.oaktree.in" },
      { property: "og:image", content: "https://www.oaktree.in/og-image.jpg" },
    ];

    ogTags.forEach(tag => {
      let ogMeta = document.querySelector(`meta[property="${tag.property}"]`);
      if (ogMeta) {
        ogMeta.setAttribute("content", tag.content);
      } else {
        const meta = document.createElement('meta');
        meta.setAttribute("property", tag.property);
        meta.content = tag.content;
        document.head.appendChild(meta);
      }
    });

    // Twitter Card Meta Tags
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Oaktree Financial Services - Financial Advisor Mumbai" },
      { name: "twitter:description", content: "Professional wealth management, retirement planning, and investment advisory services in Mumbai." },
    ];

    twitterTags.forEach(tag => {
      let twitterMeta = document.querySelector(`meta[name="${tag.name}"]`);
      if (twitterMeta) {
        twitterMeta.setAttribute("content", tag.content);
      } else {
        const meta = document.createElement('meta');
        meta.name = tag.name;
        meta.content = tag.content;
        document.head.appendChild(meta);
      }
    });

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", "https://www.oaktree.in");
    } else {
      const link = document.createElement('link');
      link.rel = "canonical";
      link.href = "https://www.oaktree.in";
      document.head.appendChild(link);
    }

    // Structured Data (JSON-LD)
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      "name": "Oaktree Financial Services",
      "image": "https://www.oaktree.in/logo.png",
      "description": "Professional financial planning, wealth management, and investment advisory services in Mumbai",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "160 Powai Plaza Hiranandani Business Park Powai",
        "addressLocality": "Mumbai",
        "postalCode": "400076",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "19.1197",
        "longitude": "72.9078"
      },
      "url": "https://www.oaktree.in",
      "telephone": "+919892303565",
      "email": "uma@oaktree.in",
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      "sameAs": [
        "https://www.linkedin.com/company/oaktree-financial-services",
        "https://www.facebook.com/oaktreefinancial"
      ]
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (script) {
      script.textContent = JSON.stringify(structuredData);
    } else {
      const newScript = document.createElement('script');
      newScript.type = "application/ld+json";
      newScript.textContent = JSON.stringify(structuredData);
      document.head.appendChild(newScript);
    }
  }, []);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!form.current) return;

    setIsSubmitting(true);
    setSubmitStatus({});

    emailjs
      .sendForm(
        "service_w8xj9yd",
        "template_skmpcyc",
        form.current,
        "CZpE4KM--mNL6RdSd"
      )
      .then(
        (result) => {
          setSubmitStatus({
            success: true,
            message: "Message sent successfully!",
          });
          form.current?.reset();
        },
        (error) => {
          setSubmitStatus({
            success: false,
            message: "Failed to send message. Please try again.",
          });
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <>
      <div className="min-h-screen w-full relative px-5 text-center lg:text-left lg:px-20 flex items-center">
  {/* Background */}
  {/* <img
    className="w-full h-full object-cover absolute top-0 left-0 z-[-1]"
    alt="Financial planning consultation in Mumbai"
  /> */}

  <div className="grid grid-cols-1 lg:grid-cols-2 gap-30 items-center w-full">

   {/* LEFT TEXT */}
<div className="max-w-xl mx-auto lg:mx-0 mt-24 lg:mt-32">
  <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight">
    At <span className="text-[#49BC31]">OAKTREE</span>, your <br />
    goals are our goals.
  </h1>

  <h2 className="text-xl sm:text-2xl lg:text-3xl py-4">
    Let's grow together.
  </h2>

  <p className="text-base sm:text-lg lg:text-xl text-[#004AAD] py-4 lg:py-6 font-medium leading-relaxed">
    We don't just plan your finances <br />
    We prepare for the life you want to live.
  </p>

  <Link
    to="/contact"
    className="inline-block mt-2 px-8 py-3 lg:px-12 lg:py-4 bg-[#49BC31] text-white text-sm lg:text-xl rounded-md"
  >
    Start Now
  </Link>
</div>

    <div className="flex justify-center">
  <div className="w-[340px] sm:w-[420px] lg:w-[480px] aspect-[9/11] rounded-2xl overflow-hidden shadow-2xl">
    <iframe
      className="w-full h-full"
      src="https://www.youtube.com/embed/EoansdUFM3w?autoplay=1&mute=1&loop=1&playlist=EoansdUFM3w&controls=1&rel=0"
      title="Oaktree Introduction"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
</div>
  </div>

  {/* WhatsApp */}
  <a
    href="https://wa.me/919892147989"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed z-[9999] bottom-16 right-4 sm:right-8 bg-green-600 hover:bg-green-700 text-black font-semibold text-lg px-5 py-3 rounded-full flex items-center gap-2 shadow-md"
  >
    <span>Chat Now</span>
    <img src={whatsappicon} className="w-6" />
  </a>
</div>
      <section className="my-20 px-5 lg:px-20 md:flex md:justify-between flex-wrap lg:flex-nowrap">
        <div className="h-auto mb-8 lg:mb-0 lg:h-[80svh] w-full lg:w-[40vw]">
          <img className="h-full w-full object-contain" src={Homegirl} alt="Professional financial advisor in Mumbai" />
        </div>

        <div className="flex flex-col justify-center items-center text-center w-full lg:w-[50%]">
          <h2 className="text-2xl lg:text-4xl font-bold">
            Good advice Truly personalized
          </h2>
          <div className="mt-10">
            <nav aria-label="Main navigation">
              <ul className="w-full">
                <li className="text-lg lg:text-3xl font-light py-5 px-12 border-b hover:text-4xl transition-all cursor-pointer">
                  <Link to="/about-us">About us</Link>
                </li>
                <li className="text-lg lg:text-3xl font-light py-5 px-12 border-b hover:text-4xl transition-all cursor-pointer">
                  <Link to="/services">Our Services</Link>
                </li>
                <li className="text-lg lg:text-3xl font-light py-5 px-12 border-b hover:text-4xl transition-all cursor-pointer">
                  <a href={brochure} download>
                    E Brochure
                  </a>
                </li>
                <li className="text-lg lg:text-3xl font-light py-5 px-12 border-b hover:text-4xl transition-all cursor-pointer">
                  <a
                    href="https://calendly.com/uma-oaktree/30min"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Book a Consultation
                  </a>
                </li>
                <li className="text-lg lg:text-3xl font-light py-5 px-12 hover:text-4xl transition-all cursor-pointer">
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      <section className="py-20 px-3 lg:px-24 bg-gradient-to-r from-teal-400 to-lime-500 w-full my-5 lg:my-40">
        <div className="bg-white p-5 lg:pt-10 lg:pr-10 lg:pl-0 lg:pb-0 rounded-4xl flex flex-col lg:flex-row items-center shadow-lg">
          <div className="w-full lg:w-1/2 text-left">
            <h2 className="text-4xl lg:text-8xl font-bold bg-gradient-to-r pl-0 lg:pl-10 from-[#00BF63] via-[#00592E] to-[#000000] bg-clip-text text-transparent">
              Our <span className="block">Mission</span>
            </h2>
            <div className="mt-6">
              <img
                src={Ourmission}
                alt="Oaktree Financial Services mission icon"
                className="block w-40 lg:w-96 relative"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 mt-6 md:mt-0">
            <p className="text-lg lg:text-4xl text-black font-medium">
              At Oaktree, we believe that financial planning is not just about
              numbers, but about creating the freedom to live your dreams. We
              guide you with care, helping you navigate life's milestones, so
              you can enjoy a secure and fulfilling future.
            </p>
          </div>
        </div>

        <div>
          <h3 className="text-4xl lg:text-6xl font-bold text-white text-center pt-20">
            Our Core Values
          </h3>

          <div className="flex flex-col lg:flex-row gap-6 mt-20">
            <article className="bg-white p-7 py-14 rounded-2xl hover:scale-[102%] transition-all">
              <h3 className="text-3xl lg:text-5xl bg-gradient-to-r from-[#00BF63] to-[#00592E] bg-clip-text text-transparent font-bold mb-5">
                Trust
              </h3>
              <p className="text-lg lg:text-2xl text-black">
                Your journey matters, and we're here to support you with honesty
                and integrity.
              </p>
            </article>
            <article className="bg-white p-7 py-14 rounded-2xl hover:scale-[102%] transition-all">
              <h3 className="text-3xl lg:text-5xl bg-gradient-to-r from-[#00BF63] to-[#00592E] bg-clip-text text-transparent font-bold mb-5">
                Care
              </h3>
              <p className="text-lg lg:text-2xl text-black">
                We listen to your needs and craft a plan that reflects your
                dreams and aspirations, empowering you with the knowledge,
                tools, and insights needed to make confident financial
                decisions.
              </p>
            </article>
          </div>
          <article className="bg-white p-7 py-14 rounded-2xl mt-6 hover:scale-[102%] transition-all">
            <h3 className="text-3xl lg:text-5xl bg-gradient-to-r from-[#00BF63] to-[#00592E] bg-clip-text text-transparent font-bold mb-5">
              Clarity
            </h3>
            <p className="text-lg lg:text-2xl text-black">
              We guide you to take control of your financial future with
              confidence and clarity, providing expert insights, personalized
              strategies, and unwavering support to help you make informed
              decisions, secure your wealth, and achieve your long-term goals.
            </p>
          </article>
        </div>

        <div className="bg-white lg:pl-10 p-5 rounded-4xl flex flex-col-reverse md:flex-row gap-6 items-center shadow-lg mt-10 lg:mt-24">
          <div className="md:w-1/2 mt-0 lg:mt-6 md:mt-0">
            <p className="text-lg lg:text-4xl text-black font-medium">
              To empower individuals worldwide with personalized financial
              guidance, we envision a world where everyone achieves their dreams
              with clarity, confidence, and financial freedom.
            </p>
          </div>

          <div className="w-full md:w-1/2 text-left">
            <h3 className="text-4xl lg:text-8xl font-bold bg-gradient-to-r from-[#00BF63] via-[#00592E] to-[#000000] bg-clip-text text-transparent">
              Our <span className="block">Vision</span>
            </h3>
            <div className="mt-6 justify-center md:justify-items-end">
              <img
                src={Ourvision}
                alt="Oaktree Financial Services vision icon"
                className="w-40 lg:w-96 relative justify-items-end"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-4xl lg:text-7xl text-center pt-0 mb-5">
          OUR SERVICES
        </h2>
        <div className="flex flex-wrap justify-center gap-6 gap-y-20 p-6 px-5 lg:px-0">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={`${category.url}#${category.name
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
              className="flex flex-col gap-3 items-center hover:scale-105 transition-all duration-300 cursor-pointer"
              onClick={() => {
                setTimeout(() => {
                  const element = document.getElementById(
                    category.name.toLowerCase().replace(/\s+/g, "-")
                  );
                  if (element) {
                    const elementRect = element.getBoundingClientRect();
                    const absoluteElementTop =
                      elementRect.top + window.pageYOffset;
                    const middle = absoluteElementTop - window.innerHeight / 2;
                    window.scrollTo({ top: middle, behavior: "smooth" });
                  }
                }, 100);
              }}
            >
              <div className="relative w-[18rem] h-[18rem] rounded-4xl overflow-hidden shadow-lg">
                <img
                  src={category.img}
                  alt={`${category.name} financial planning services in Mumbai`}
                  className="w-full h-full object-cover"
                />
              </div>
              <button className="font-bold w-full mt-3 bg-[#43AD7C] text-white px-4 py-3 rounded-4xl flex justify-center items-center gap-2 shadow-md relative">
                {category.name}
              </button>
            </Link>
          ))}
        </div>
      </section>

      <section className="px-3 lg:px-20 bg-gradient-to-r from-teal-400 to-lime-500 mt-8 lg:mt-40">
        <h2 className="text-3xl lg:text-6xl text-center pt-8 lg:pt-32">
          What Our Clients Say
        </h2>
        <div className="mt-8 lg:mt-24 pb-8 lg:pb-32">
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            autoplay={{ delay: 2000 }}
            breakpoints={{
              1080: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
            }}
            modules={[Autoplay]}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <article className="bg-white p-5 rounded-2xl min-h-[280px] flex flex-col justify-between">
                  <p className="text-2xl text-black font-light">
                    {item.testimonial}
                  </p>
                  <div className="flex items-center gap-3">
                    <img
                      className="w-10 h-10 object-cover rounded-full"
                      src={item.profileImg}
                      alt={`${item.name} - Oaktree client testimonial`}
                    />
                    <div>
                      <p className="font-medium">{item.name}</p>
                      <span className="text-black/70 text-sm">
                        {item.position}
                      </span>
                    </div>
                  </div>
                </article>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-30 items-start px-3 lg:px-40 py-10 lg:py-30">
        <div className="justify-items-start">
          <h2 className="text-4xl lg:text-7xl font-bold text-[#49BC31] mb-1 lg:mb-5">
            Ready To
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold text-black mb-3">
            Start Your Journey?
          </h3>
          <p className="text-sm text-black mb-6 font-bold lg:text-base">
            Take control of your financial future now with personalized planning
            and expert guidance.
          </p>

          <address className="not-italic">
            <div className="flex items-center mt-20 mb-4">
              <span className="bg-yellow-100 p-2 rounded-full text-yellow-500 mr-3">
                📞
              </span>
              <a href="tel:+919892303565" className="text-base text-black font-semibold">
                9892303565 / +91 89289 93593
              </a>
            </div>
            <div className="flex items-center mb-4">
              <span className="bg-yellow-100 p-2 rounded-full text-yellow-500 mr-3">
                ✉️
              </span>
              <a href="mailto:uma@oaktree.in" className="text-base text-black font-semibold">
                uma@oaktree.in / www.oaktree.in
              </a>
            </div>
            <div className="flex items-center">
              <span className="bg-yellow-100 p-2 rounded-full text-yellow-500 mr-3">
                📍
              </span>
              <span className="text-base text-black font-semibold">
                160 Powai Plaza Hiranandani Business Park Powai Mumbai-400076
              </span>
            </div>
          </address>
        </div>

        <form
          ref={form}
          onSubmit={sendEmail}
          className="bg-white rounded-lg mb-4"
          aria-label="Contact form for financial consultation"
        >
          <div className="grid grid-cols-1 gap-4 mb-4">
            <div className="flex flex-col mb-4">
              <label
                htmlFor="name"
                className="mb-2 text-lg font-bold text-black"
              >
                Name
              </label>
              <input
                id="name"
                name="user_name"
                type="text"
                className="bg-[#E0D6AD] p-3 rounded w-full"
                required
                aria-required="true"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div className="flex flex-col">
                <label
                  htmlFor="email"
                  className="text-lg font-bold text-black mb-2"
                >
                  Email
                </label>
                <input
                  id="email"
                  name="user_email"
                  type="email"
                  className="bg-[#E0D6AD] p-3 rounded w-full"
                  required
                  aria-required="true"
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="phone"
                  className="mb-2 text-lg font-bold text-black"
                >
                  Phone Number
                </label>
                <input
                  id="phone"
                  name="user_phone"
                  type="tel"
                  className="bg-[#E0D6AD] p-3 rounded w-full"
                  required
                  aria-required="true"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col mb-4">
            <label
              htmlFor="message"
              className="mb-2 text-lg font-bold text-black"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              className="bg-[#E0D6AD] p-3 rounded w-full h-32"
              required
              aria-required="true"
            ></textarea>
          </div>

          {submitStatus.message && (
            <div
              className={`p-3 rounded mb-4 ${
                submitStatus.success
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
              role="alert"
            >
              {submitStatus.message}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className={`bg-yellow-400 px-6 py-2 rounded hover:bg-yellow-500 font-semibold mt-8 ${
              isSubmitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isSubmitting ? "SENDING..." : "SUBMIT NOW"}
          </button>
        </form>
      </section>
    </>
  );
}